import Header from "../components/header";
import SupportIndex from "../components/support";
import { useSupport } from "../hooks/supportStore";

function Support() {
  const support = useSupport();

  return (
    <div className="cs-page">
      <Header userDetails={support.me} inProfile={true} />
      <SupportIndex />
    </div>
  );
}

export default Support;
